export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7360.a1375e8d.jpg";